
export default function About() {
  const values = [
    {
      icon: 'ri-shield-check-line',
      title: 'Job Security',
      description: 'We help employees become irreplaceable by mastering AI tools, not replacing them with automation.'
    },
    {
      icon: 'ri-heart-line',
      title: 'Genuine Care',
      description: 'We genuinely want to help save jobs and empower people to thrive in an AI-enhanced workplace.'
    },
    {
      icon: 'ri-book-open-line',
      title: 'Education First',
      description: 'Starting from zero with pure education ensures everyone understands AI before implementation.'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Local Focus',
      description: 'Dedicated to serving Northwest Georgia small town businesses with personalized, hands-on support.'
    }
  ];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-block mb-4 px-4 py-2 bg-navy/10 rounded-md">
              <span className="text-navy text-base font-semibold">Our Approach</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-navy">
              Why <span className="text-gold">Evernorth AI</span>
            </h2>
            <p className="text-lg text-charcoal mb-8 leading-relaxed">
              Our approach is calm, hands-on, and designed for beginners. No tech jargon. No pressure. No unrealistic promises.
            </p>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-navy/10 rounded-lg flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-navy"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2 text-navy">Local Partner</h3>
                  <p className="text-charcoal">
                    Committed to Northwest Georgia businesses and their success.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-navy/10 rounded-lg flex-shrink-0">
                  <i className="ri-user-heart-line text-2xl text-navy"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2 text-navy">Beginner-Friendly Training</h3>
                  <p className="text-charcoal">
                    Designed specifically for non-technical teams who are new to AI.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-navy/10 rounded-lg flex-shrink-0">
                  <i className="ri-file-list-3-line text-2xl text-navy"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2 text-navy">Real Examples</h3>
                  <p className="text-charcoal">
                    Training tied to everyday office work your team already does.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-navy/10 rounded-lg flex-shrink-0">
                  <i className="ri-settings-3-line text-2xl text-navy"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2 text-navy">Simple Solutions First</h3>
                  <p className="text-charcoal">
                    We start with simple, practical solutions before moving to complex ones.
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-8 p-6 bg-gradient-to-br from-navy/5 to-gold/5 rounded-2xl border border-navy/10">
              <p className="text-charcoal text-lg font-medium">
                Our goal is to help your team feel capable and prepared as AI becomes part of normal work. We prevent Northwest Georgia businesses from falling behind by making AI adoption simple, safe, and specific to their operations.
              </p>
              <p className="text-navy font-bold text-xl mt-4">
                We don't sell hype. We sell clarity.
              </p>
            </div>
          </div>

          <div className="relative">
            <div className="relative h-[600px] w-full rounded-2xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/d306acce640bbe6e33338ad5a85786f4.jpg"
                alt="Evernorth AI Team"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/40 to-transparent"></div>
            </div>

            <div className="absolute -bottom-8 -left-8 bg-gradient-to-br from-gold to-[#a68a4e] p-8 rounded-2xl shadow-2xl max-w-xs">
              <div className="text-4xl font-bold text-white mb-2">100+</div>
              <div className="text-white/90 text-sm">Businesses Empowered with AI Knowledge</div>
            </div>
          </div>
        </div>

        <div className="mt-24 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((value, index) => (
            <div
              key={index}
              className="bg-[#f8f8f9] p-6 rounded-xl border border-soft-gray/30 hover:border-gold/50 transition-all"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-gold/10 rounded-lg mb-4">
                <i className={`${value.icon} text-2xl text-gold`}></i>
              </div>
              <h3 className="text-lg font-bold mb-2 text-navy">{value.title}</h3>
              <p className="text-sm text-charcoal leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
